import React from 'react';
import { AboutUs } from '../../components';
import { homeObjOne, homeObjTwo } from './Data';

function Products() {
  return (
    <>
      <AboutUs {...homeObjOne} />
      <AboutUs {...homeObjTwo} />
    </>
  );
}

export default Products;
